'use client';

import React, { FC } from 'react';

import styles from './part-services-decor.module.scss';

import data from './data';

const PartServicesDecor: FC = () => (
  <div className={styles.container}>
    <ul className={styles.wrap}>
      {data.map((item) => (
        <li key={item.id} className={styles.item}>
          {item.icon}
        </li>
      ))}
    </ul>
  </div>
);

export default PartServicesDecor;
